import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
// import { ServiceOutputContextmenuComponent } from '@app/core/components/contextmenus';
import { CreateEditExpenseComponent } from '@app/core/windows'; 


@Component({
  selector: 'expenses-crud',
  templateUrl: './expenses-crud.component.html',
  providers: [ DatasourceService ]
})
export class ExpensesCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditExpenseComponent, {static: false}) window !: CreateEditExpenseComponent;

  //Menu
  // @ViewChild(ServiceOutputContextmenuComponent, {static: false}) menu_ser !: ServiceOutputContextmenuComponent;

  protected menu: string = 'Movimientos';

  protected menuIcon: string = 'arrows-swap';
  
  protected label: string = 'Gasto';

  protected name: string = 'Gastos';

  protected table: string = 'expenses_inventories';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'date', dir: 'desc'}
    ];

    return s;

  }

  public onCustomExcelExport(e: any, allData: Array<any>): void {

    console.log('onCustomExcelExport');

    const rows = e.workbook.sheets[0].rows;

    let index = 0;
    rows.forEach((row) => {
      if (row.type === 'data') {+
        index++;
        row.cells.forEach((cell, i) => {
          if(typeof cell._column != 'undefined'){
            switch(cell._column){
              // case 'Estatus': {
              //   cell.background = '#' + allData[index-1].service_status_color;
              //   cell.color = '#ffffff';
              // }; break;
              case 'Costo': {
                cell.format = "$#,##0.00";
              }; break;
            }
          }
        });
      }
    });

  }

  public onCellClick(e: any): void {
      
    console.log(e);
    if (e.type === 'contextmenu') {
      const originalEvent = e.originalEvent;
      originalEvent.preventDefault();
      // this.menu_proy.label = 'Folio consecutivo: ' + e.dataItem.folio_consecutivo;
      // this.menu_ser.contextItem = e.dataItem;
      // this.menu_ser.menu.show({ left: originalEvent.pageX, top: originalEvent.pageY });
    }

  }

  // public dblClickEvent(e : any) : void {

  //   // console.log('dblClickEvent', e);
  //   if (e.path[1].nodeName === 'TR') {
  //     let index = e.path[1].rowIndex;
  //     let data : DataResult = this.grid.data as DataResult;
  //     this.permissions.edit(data.data[index]);
  //   }

  // }

  public selectMenu({ menu, contextItem }): void {
    
    // console.log("selectMenu", menu, contextItem);

    if (menu.url === 'editar') {

      this.window.label = this.label;
      this.window.table = this.table;
      this.window.edit(contextItem);

    } else if (menu.url === 'eliminar') {
        
      this.removeHandler({dataItem: contextItem});

    }

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}